export default __webpack_public_path__ + "static/media/Ham Menu_2px.3a1e4330.svg";